var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "102px",
    height: "102px",
    viewBox: "0 0 102 102",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 51,
    cy: 51,
    r: 51
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03-Company",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFEFEF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#AEAEAE",
    id: "Path"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,28 C25.2669091,28 19,21.7330909 19,14 C19,6.26690909 25.2669091,0 33,0 C40.7330909,0 47,6.26690909 47,14 C47,21.7330909 40.7330909,28 33,28 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1970909,48.0624 C65.7330909,49.2816 66.1076818,51.0384 66.4335455,53.3712 C66.598,54.5584 66.7380909,55.8192 66.8538182,57.08 C66.8934091,57.5184 66.9269091,57.928 66.9573636,58.296 C66.9756364,58.5168 66.9847727,58.68 66.9908636,58.7728 L67,59 C67,63.4128 63.5951818,67 59.3955,67 L7.6045,67 C3.40481818,67 0,63.4128 0,59 L0.00913636364,58.7728 C0.0152272727,58.68 0.0243636364,58.5168 0.0426363636,58.296 C0.0730909091,57.928 0.106590909,57.5184 0.146181818,57.08 C0.261909091,55.8192 0.402,54.5584 0.566454545,53.3712 C0.892318182,51.0384 1.26690909,49.2816 1.80290909,48.0624 C4.14181818,42.7248 21.373,35 33.5,35 C45.627,35 62.8581818,42.7248 65.1970909,48.0624 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUserProfile);
export default __webpack_public_path__ + "static/media/No_User_Profile.9f17961c6e9cf1f5b7321b239296165e.svg";
export { ForwardRef as ReactComponent };